import axios from 'axios';
import { API_URL } from '@/constants/config';
import { EKeyStore, StoreUtils } from '@/utils/localStore';

const http = axios.create({
  baseURL: API_URL,
  timeout: 30 * 1000,
  headers: {
    'Content-Type': 'application/json',
  },
});

http.interceptors.request.use(
  function (config: any) {
    const token = StoreUtils.get(EKeyStore.AccessToken);

    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }

    delete config.headers.accept;

    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => response,

  async function (error: any) {
    const status = error?.response?.status;
    const originalRequest = error.config;

    if ((status === 401 || status === 500) && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = StoreUtils.get(EKeyStore.RefreshToken);

        if (!refreshToken) {
          StoreUtils.remove(EKeyStore.AccessToken);
          StoreUtils.remove(EKeyStore.RefreshToken);
          StoreUtils.remove(EKeyStore.Auth);
          StoreUtils.remove(EKeyStore.MyProfile);

          window.location.href = '/login';
          return Promise.reject(error);
        }
        console.log('old-refresh', refreshToken);

        const res = await axios.post(`${API_URL}/auth/refresh-token`, null, {
          headers: {
            Authorization: 'Bearer ' + refreshToken,
          },
        });

        const newAccessToken = res.data.accessToken;
        const newRefreshToken = res.data.refreshToken;
        StoreUtils.set(EKeyStore.AccessToken, newAccessToken);
        StoreUtils.set(EKeyStore.RefreshToken, newRefreshToken);

        error.config.headers['Authorization'] = 'Bearer ' + newAccessToken;
        return http(error.config);
      } catch (err) {
        StoreUtils.remove(EKeyStore.AccessToken);
        StoreUtils.remove(EKeyStore.RefreshToken);
        StoreUtils.remove(EKeyStore.Auth);
        StoreUtils.remove(EKeyStore.MyProfile);

        window.location.href = '/login';
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export { http };
